var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"cell-line-one"},[_vm._v(" "+_vm._s(_vm.impact))])])}
var staticRenderFns = []

export { render, staticRenderFns }